import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M4.5 1H9.79297L13.5 4.70703V14C13.5 14.4229 13.3946 14.6483 13.2715 14.7715C13.1483 14.8946 12.9229 15 12.5 15H4.5C4.07707 15 3.85168 14.8946 3.72852 14.7715C3.60536 14.6483 3.5 14.4229 3.5 14V2C3.5 1.57707 3.60536 1.35168 3.72852 1.22852C3.85168 1.10536 4.07707 1 4.5 1Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10 0.5V3.7C10 4.23333 10.2667 4.5 10.8 4.5H14L10 0.5Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 8,
					width: 11.5,
					height: 6,
					rx: 1,
					fill: "#C93829"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.53445 12.5V9.22726H3.82564C4.07386 9.22726 4.28533 9.27467 4.46005 9.36949C4.63477 9.46324 4.76793 9.59374 4.85955 9.761C4.95224 9.92719 4.99858 10.119 4.99858 10.3363C4.99858 10.5536 4.95171 10.7454 4.85796 10.9116C4.76421 11.0778 4.62837 11.2072 4.45046 11.2999C4.27362 11.3926 4.05948 11.4389 3.80806 11.4389H2.98509V10.8844H3.6962C3.82937 10.8844 3.9391 10.8615 4.02539 10.8157C4.11275 10.7688 4.17774 10.7044 4.22035 10.6223C4.26403 10.5392 4.28587 10.4439 4.28587 10.3363C4.28587 10.2276 4.26403 10.1328 4.22035 10.0518C4.17774 9.96981 4.11275 9.90642 4.02539 9.86167C3.93803 9.81587 3.82724 9.79296 3.693 9.79296H3.22639V12.5H2.53445Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.69818 12.5H5.53802V9.22726H6.70777C7.03696 9.22726 7.32034 9.29278 7.55791 9.42382C7.79548 9.55379 7.97818 9.74076 8.10603 9.98472C8.23493 10.2287 8.29938 10.5206 8.29938 10.8604C8.29938 11.2013 8.23493 11.4943 8.10603 11.7393C7.97818 11.9844 7.79441 12.1724 7.55471 12.3034C7.31607 12.4345 7.03056 12.5 6.69818 12.5ZM6.22996 11.9071H6.66941C6.87396 11.9071 7.04601 11.8709 7.18557 11.7985C7.3262 11.725 7.43166 11.6115 7.50198 11.4581C7.57335 11.3036 7.60904 11.1044 7.60904 10.8604C7.60904 10.6186 7.57335 10.421 7.50198 10.2676C7.43166 10.1142 7.32673 10.0012 7.18717 9.92879C7.04761 9.85635 6.87556 9.82013 6.67101 9.82013H6.22996V11.9071Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.90195 12.5V9.22726H11.0688V9.79775H9.59389V10.5776H10.925V11.1481H9.59389V12.5H8.90195Z",
					fill: "white"
				})
			]
		}),
		width: 16,
		height: 16
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M6 1.5H14.793L19.5 6.20703V21C19.5 21.5896 19.353 21.94 19.1465 22.1465C18.94 22.353 18.5896 22.5 18 22.5H6C5.41041 22.5 5.06001 22.353 4.85352 22.1465C4.64702 21.94 4.5 21.5896 4.5 21V3C4.5 2.41041 4.64702 2.06001 4.85352 1.85352C5.06001 1.64702 5.41041 1.5 6 1.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15 1V5C15 5.66667 15.3333 6 16 6H20L15 1Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 12,
					width: 16,
					height: 8,
					rx: 1.5,
					fill: "#C93829"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.37926 18.5V14.1364H5.10086C5.43182 14.1364 5.71378 14.1996 5.94674 14.326C6.17969 14.451 6.35725 14.625 6.47941 14.848C6.60299 15.0696 6.66478 15.3253 6.66478 15.615C6.66478 15.9048 6.60228 16.1605 6.47728 16.3821C6.35228 16.6037 6.17117 16.7763 5.93395 16.8998C5.69816 17.0234 5.41265 17.0852 5.07742 17.0852H3.98012V16.3459H4.92827C5.10583 16.3459 5.25213 16.3153 5.36719 16.2543C5.48367 16.1918 5.57032 16.1058 5.62713 15.9964C5.68537 15.8856 5.71449 15.7585 5.71449 15.615C5.71449 15.4702 5.68537 15.3437 5.62713 15.2358C5.57032 15.1264 5.48367 15.0419 5.36719 14.9822C5.25071 14.9212 5.10299 14.8906 4.92401 14.8906H4.30185V18.5H3.37926Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.93091 18.5H7.38403V14.1364H8.94369C9.38261 14.1364 9.76045 14.2237 10.0772 14.3984C10.394 14.5717 10.6376 14.821 10.808 15.1463C10.9799 15.4716 11.0658 15.8608 11.0658 16.3139C11.0658 16.7685 10.9799 17.1591 10.808 17.4858C10.6376 17.8125 10.3926 18.0632 10.073 18.2379C9.75477 18.4126 9.37409 18.5 8.93091 18.5ZM8.30662 17.7095H8.89255C9.16528 17.7095 9.39468 17.6612 9.58076 17.5646C9.76826 17.4666 9.90889 17.3153 10.0026 17.1108C10.0978 16.9048 10.1454 16.6392 10.1454 16.3139C10.1454 15.9915 10.0978 15.728 10.0026 15.5234C9.90889 15.3189 9.76897 15.1683 9.58289 15.0717C9.39681 14.9751 9.16741 14.9268 8.89468 14.9268H8.30662V17.7095Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.8693 18.5V14.1364H14.7585V14.897H12.7919V15.9368H14.5667V16.6974H12.7919V18.5H11.8693Z",
					fill: "white"
				})
			]
		}),
		width: 24,
		height: 24
	},
	40: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 40 40",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M10 2.5H24.793L32.5 10.207V35C32.5 35.9229 32.2696 36.5233 31.8965 36.8965C31.5233 37.2696 30.9229 37.5 30 37.5H10C9.07707 37.5 8.47668 37.2696 8.10352 36.8965C7.73036 36.5233 7.5 35.9229 7.5 35V5C7.5 4.07707 7.73036 3.47668 8.10352 3.10352C8.47668 2.73036 9.07707 2.5 10 2.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25 2V9C25 9.66667 25.3333 10 26 10H33L25 2Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 3,
					y: 21,
					width: 24,
					height: 13,
					rx: 2,
					fill: "#C93829"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.56889 31V24.4546H9.15128C9.64773 24.4546 10.0707 24.5494 10.4201 24.739C10.7695 24.9265 11.0359 25.1875 11.2191 25.522C11.4045 25.8544 11.4972 26.2379 11.4972 26.6726C11.4972 27.1073 11.4034 27.4908 11.2159 27.8232C11.0284 28.1556 10.7567 28.4144 10.4009 28.5998C10.0472 28.7852 9.61896 28.8779 9.11612 28.8779H7.47017V27.7688H8.8924C9.15874 27.7688 9.3782 27.723 9.55078 27.6314C9.7255 27.5377 9.85547 27.4087 9.9407 27.2447C10.0281 27.0785 10.0717 26.8878 10.0717 26.6726C10.0717 26.4553 10.0281 26.2656 9.9407 26.1037C9.85547 25.9396 9.7255 25.8129 9.55078 25.7234C9.37607 25.6318 9.15448 25.586 8.88601 25.586H7.95277V31H6.56889Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.8964 31H12.576V24.4546H14.9155C15.5739 24.4546 16.1407 24.5856 16.6158 24.8477C17.091 25.1076 17.4564 25.4815 17.7121 25.9695C17.9699 26.4574 18.0988 27.0412 18.0988 27.7209C18.0988 28.4027 17.9699 28.9887 17.7121 29.4787C17.4564 29.9688 17.0888 30.3448 16.6094 30.6069C16.1321 30.869 15.5611 31 14.8964 31ZM13.9599 29.8143H14.8388C15.2479 29.8143 15.592 29.7418 15.8711 29.597C16.1524 29.4499 16.3633 29.223 16.504 28.9162C16.6467 28.6073 16.7181 28.2088 16.7181 27.7209C16.7181 27.2372 16.6467 26.842 16.504 26.5352C16.3633 26.2284 16.1535 26.0025 15.8743 25.8576C15.5952 25.7127 15.2511 25.6403 14.842 25.6403H13.9599V29.8143Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.3039 31V24.4546H23.6377V25.5955H20.6878V27.1552H23.3501V28.2962H20.6878V31H19.3039Z",
					fill: "white"
				})
			]
		}),
		width: 40,
		height: 40
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as FilePdfIcon };
